import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { MySpendDto } from '../lib/types';

export function useMySpend(months = 6) {
  return useQuery({
    queryKey: ['me', 'spend', months],
    queryFn: () => apiClient.get<MySpendDto>(`/api/me/spend?months=${months}`),
    staleTime: 60_000
  });
}
